import urls from '../constants/urls'

import {
  gatherErrors
} from '../utils/errorHandling'

export const CREATE_WHITELISTED_DOMAIN_FAILED = 'whitelistedDomains/CREATE_FAILED'
export const CREATE_WHITELISTED_DOMAIN_SUCCESS = 'whitelistedDomains/CREATE_SUCCESS'
export const CREATING_WHITELISTED_DOMAIN = 'whitelistedDomains/CREATING'

export const DESTROY_WHITELISTED_DOMAIN_FAILED = 'whitelistedDomains/DESTROY_FAILED'
export const DESTROY_WHITELISTED_DOMAIN_SUCCESS = 'whitelistedDomains/DESTROY_SUCCESS'
export const DESTROYING_WHITELISTED_DOMAIN = 'whitelistedDomains/DESTROYING'

export const LOAD_WHITELISTED_DOMAINS_FAILED = 'whitelistedDomains/LOAD_FAILED'
export const LOAD_WHITELISTED_DOMAINS_SUCCESS = 'whitelistedDomains/LOAD_SUCCESS'
export const LOADING_WHITELISTED_DOMAINS = 'whitelistedDomains/LOADING'

const initialState = {
  domains: [],

  createErrors: {},

  failedCreating:   false,
  failedDestroying: false,
  failedLoading:    false,

  hasLoaded: false,

  isCreating:   false,
  isDestroying: false,
  isLoading:    false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATING_WHITELISTED_DOMAIN:
      return {
        ...state,
        createErrors:   {},
        isCreating:     true,
        failedCreating: false
      }

    case CREATE_WHITELISTED_DOMAIN_SUCCESS:
      return {
        ...state,
        createErrors: {},
        isCreating:   false,
        domains:      state.domains.concat(action.payload.data)
      }

    case CREATE_WHITELISTED_DOMAIN_FAILED:
      return {
        ...state,
        createErrors:   gatherErrors(action.error, 'create_whitelisted_domain_failed'),
        isCreating:     false,
        failedCreating: true
      }

    case DESTROYING_WHITELISTED_DOMAIN:
      return {
        ...state,
        isDestroying:     true,
        failedDestroying: false
      }

    case DESTROY_WHITELISTED_DOMAIN_SUCCESS:
      return {
        ...state,
        isDestroying: false
      }

    case DESTROY_WHITELISTED_DOMAIN_FAILED:
      return {
        ...state,
        isDestroying:     false,
        failedDestroying: true
      }

    case LOADING_WHITELISTED_DOMAINS:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case LOAD_WHITELISTED_DOMAINS_SUCCESS:
      return {
        ...state,
        domains:       action.payload.data,
        total:         action.payload.headers['x-total'],
        pages:         action.payload.headers['x-pages'],
        page:          action.payload.headers['x-pages'],
        isLoading:     false,
        failedLoading: false,
        hasLoaded:     true
      }

    case LOAD_WHITELISTED_DOMAINS_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    default:
      return state
  }
}

export const loadDomains = (hospital, page) => (dispatch) => {
  return dispatch({
    types:   [LOADING_WHITELISTED_DOMAINS, LOAD_WHITELISTED_DOMAINS_SUCCESS, LOAD_WHITELISTED_DOMAINS_FAILED],
    payload: {
      request: {
        url:    urls.hospitals.whitelistedDomains.index(hospital.id),
        params: { page }
      }
    }
  })
}

export const createDomain = (hospitalId, params) => (dispatch) => {
  return dispatch({
    types:   [CREATING_WHITELISTED_DOMAIN, CREATE_WHITELISTED_DOMAIN_SUCCESS, CREATE_WHITELISTED_DOMAIN_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.hospitals.whitelistedDomains.create(hospitalId),
        data:   { whitelisted_domain: params }
      }
    }
  })
}

export const destroyDomain = (hospitalId, inviteId) => (dispatch) => {
  return dispatch({
    types:   [DESTROYING_WHITELISTED_DOMAIN, DESTROY_WHITELISTED_DOMAIN_SUCCESS, DESTROY_WHITELISTED_DOMAIN_FAILED],
    payload: {
      request: {
        method: 'delete',
        url:    urls.hospitals.whitelistedDomains.destroy(hospitalId, inviteId)
      }
    }
  })
}
